module.exports = __webpack_public_path__ + "media/images/referrals/aging-adults-8d1d28fa183dad38e64595474d6b7491.png";